"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationNoMandat = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var task_ok_svg_1 = __importDefault(require("../../assets/img/task_ok.svg"));

var process_error_svg_1 = __importDefault(require("../../assets/img/process-error.svg"));

var Header_1 = require("../../components/Header");

exports.ConfirmationNoMandat = function (_a) {
  var loaderDlPdf = _a.loaderDlPdf,
      dlPdfMandat = _a.dlPdfMandat,
      changePaymentMethod = _a.changePaymentMethod,
      toDashoard = _a.toDashoard,
      _b = _a.status,
      status = _b === void 0 ? "OK" : _b,
      messageError = _a.messageError,
      srcLogo = _a.srcLogo,
      currentBrandCode = _a.currentBrandCode,
      destClose = _a.destClose;
  var argsHeader = {
    srcLogo: srcLogo,
    currentBrandCode: currentBrandCode,
    labelClose: "Quitter le paiement",
    destClose: destClose
  };
  var textes = {
    titlePaymentChoice: "Revenir à l'espace facturation",
    withMandat: {
      subtitle: "Vous allez recevoir un e-mail de confirmation avec les informations de la transaction."
    },
    noMandat: {
      subtitle: "Vous allez recevoir un e-mail de confirmation avec les informations de la transaction ainsi que le mandat SPS que vous avez signé.",
      secondSubtitle: " Pour votre prochain paiement auto, votre mandat est enregistré, vous pourrez payer en un clic depuis votre compte en ligne."
    },
    status: {
      OK: {
        title: "Demande de prélèvement enregistrée avec succès"
      },
      KO: {
        title: "Demande de prélèvement echouée",
        subtitle: "Texte complémentaire .. Et prima post Osdroenam quam, ut dictum est, ab hac descriptione discrevimus, Commagena, nunc Euphratensis, clementer adsurgit, Hierapoli, vetere Nino et Samosata civitatibus amplis inlustris."
      },
      CANCEL: {
        title: "Demande de prélèvement annulée",
        subtitle: "Texte complémentaire .. Et prima post Osdroenam quam, ut dictum est, ab hac descriptione discrevimus, Commagena, nunc Euphratensis, clementer adsurgit, Hierapoli, vetere Nino et Samosata civitatibus amplis inlustris."
      }
    }
  };
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Header_1.Header, __assign({}, argsHeader)), react_1.default.createElement("div", {
    className: "container bg-white mt-5 pt-3 pb-4 pt-md-5 px-0 px-md-5"
  }, react_1.default.createElement("div", {
    className: "row"
  }, react_1.default.createElement("div", {
    className: "col-12 col-md-8"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "huge",
    className: "h1 mb-0 d-none d-md-block",
    weight: "bold"
  }, textes.status[status].title), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "mb-0 d-block d-md-none",
    weight: "bold"
  }, textes.status[status].title), react_1.default.createElement("div", {
    className: "row mt-4 mb-2 mb-md-5"
  }, status === "OK" ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "col-12 col-md-9",
    variant: "caption",
    weight: "medium",
    color: "disabled"
  }, textes.noMandat.subtitle), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "col-12 col-md-9 mt-2",
    variant: "caption",
    weight: "medium",
    color: "disabled"
  }, textes.noMandat.secondSubtitle)) : react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "col-12 col-md-9",
    variant: "caption",
    weight: "medium",
    color: "disabled"
  }, textes.status[status].subtitle)), react_1.default.createElement("div", {
    className: "row d-block d-md-none"
  }, status === "OK" ? react_1.default.createElement("img", {
    src: task_ok_svg_1.default,
    alt: "tache ok",
    className: "col-12"
  }) : react_1.default.createElement("img", {
    src: process_error_svg_1.default,
    alt: "tache ko",
    className: "col-12"
  })), react_1.default.createElement("div", {
    className: "row text-center  text-md-left"
  }, status === "OK" ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: "col-12 col-md-5 mb-4 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    icon: "common-file-text-download",
    className: "cy-btn-download-mandat",
    loader: loaderDlPdf,
    onClick: dlPdfMandat
  }, "T\xE9l\xE9charger le mandat")), react_1.default.createElement("div", {
    className: "col-12 col-md-5 mb-4 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    variant: "tertiary",
    icon: "layout-dashboard",
    onClick: toDashoard
  }, "Aller au tableau de bord"))) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: "col-12 col-md-6 mb-4 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    icon: "synchronize-arrow-1",
    onClick: changePaymentMethod
  }, textes.titlePaymentChoice)), react_1.default.createElement("div", {
    className: "col-12 col-md-6 mb-4 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    variant: "tertiary",
    icon: "layout-dashboard",
    onClick: toDashoard
  }, "Aller au tableau de bord"))))), react_1.default.createElement("div", {
    className: "col-12 col-md-4 d-none d-md-block"
  }, status === "OK" ? react_1.default.createElement("img", {
    src: task_ok_svg_1.default,
    alt: "tache ok",
    className: " pt-4 pl-5"
  }) : react_1.default.createElement("img", {
    src: process_error_svg_1.default,
    alt: "tache ok",
    className: " pt-4 pl-5"
  })))), messageError && react_1.default.createElement("div", {
    className: "container mt-4 pt-3 pb-4 pt-md-0 px-0 px-md-5"
  }, react_1.default.createElement(react_theme_components_1.SzAlert, {
    variant: "danger",
    className: "cy-error-message col-12 mb-0 bg-transparent"
  }, messageError)));
};

exports.default = exports.ConfirmationNoMandat;